import React from 'react'
import Portal from 'components/Portal/Portal'
import SlidingPanel from 'components/SlidingPanel/SlidingPanel'
import Checkout from 'components/Checkout/Checkout'
import PropTypes from 'prop-types'

const CheckoutSlider = ({
  isOpen,
  onRequestClose,
  onCancel,
  onTransactionComplete,
  amendmentNum,
  formDefinitionId,
  category,
  correctionMode,
  webCart,
  skipCartQuantityUpdate
}) => {
  const slider = React.useRef()

  const handleCancel = () => {
    slider.current.closeSlider(() => {
      if (typeof onCancel === 'function') {
        onCancel()
      }
      onRequestClose()
    })
  }

  return (
    <Portal isOpened={isOpen}>
      <SlidingPanel
        closeOnShadeClick={false}
        closeSlider={onRequestClose}
        ref={slider}
        ariaLabel="Checkout"
      >
        {webCart && (
          <Checkout
            cancelCheckout={handleCancel}
            closeModal={onRequestClose}
            redirectToReceipt={(refNum) => {
              onTransactionComplete((callback) => {
                slider.current.closeSlider(callback)
              }, refNum)
            }}
            amendmentNum={amendmentNum}
            formDefinitionId={formDefinitionId}
            category={category}
            correctionMode={correctionMode}
            receiptItems={webCart.RECEIPT_ITEM_WEB_LIST}
            receiptItemContainers={webCart.RECEIPT_ITEM_CONTAINER_WEB_LIST}
            refNum={webCart.REF_NUM}
            availableMethods={webCart.PAYMENT_METHOD_STATUS_LIST}
            skipCartQuantityUpdate={skipCartQuantityUpdate}
          />
        )}
      </SlidingPanel>
    </Portal>
  )
}

CheckoutSlider.propTypes = {
  isOpen: PropTypes.bool,
  onRequestClose: PropTypes.func.isRequired,
  onCancel: PropTypes.func,
  onTransactionComplete: PropTypes.func,
  amendmentNum: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  formDefinitionId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  category: PropTypes.string,
  correctionMode: PropTypes.bool,
  webCart: PropTypes.object,
}

export default CheckoutSlider



// WEBPACK FOOTER //
// ./src/components/Checkout/CheckoutSlider.js